import {
  DragEventHandler,
  FC,
  MouseEventHandler,
  PropsWithChildren,
} from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';

import { $ClickableCard } from './ClickableCard.styles';

interface ClickableCardProps {
  isFluid?: boolean;
  onClick: MouseEventHandler;
  draggable?: boolean;
  onDragStart?: DragEventHandler<HTMLButtonElement>;
  onDragOver?: DragEventHandler<HTMLButtonElement>;
  onDrop?: DragEventHandler<HTMLButtonElement>;
  onDragEnd?: DragEventHandler<HTMLButtonElement>;
  isGrabbed?: boolean;
  shouldDisplayHoverStatus?: boolean;
  isActive?: boolean;
  dataTestId?: string;
  type?: BUTTON_TYPES;
  title?: string;
  isDisabled?: boolean;
  isNaked?: boolean;
  hasPadding?: boolean;
}

export const ClickableCard: FC<PropsWithChildren<ClickableCardProps>> = ({
  onClick,
  isFluid,
  children,
  dataTestId,
  type = BUTTON_TYPES.SUBMIT,
  title,
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  isGrabbed,
  shouldDisplayHoverStatus = false,
  isActive = false,
  isDisabled = false,
  isNaked = false,
  hasPadding = true,
}) => {
  if (!children) {
    return null;
  }

  return (
    <$ClickableCard
      $isFluid={isFluid}
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      $isGrabbed={isGrabbed}
      $shouldDisplayHoverStatus={shouldDisplayHoverStatus}
      $isActive={isActive}
      data-testid={dataTestId}
      type={type}
      title={title}
      disabled={isDisabled}
      $isDisabled={isDisabled}
      $isNaked={isNaked}
      $hasPadding={hasPadding}
    >
      {children}
    </$ClickableCard>
  );
};
